var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6357 12.4645H3.97888V12.4622M28.0205 26.1925V19.5356M28.0205 19.5356L21.3637 19.5356M28.0205 19.5356L23.7793 23.7796C22.4586 25.1028 20.7825 26.1066 18.8469 26.6253C12.9787 28.1976 6.94704 24.7152 5.37468 18.8471M26.625 13.1531C25.0527 7.28497 19.021 3.80256 13.1529 5.37492C11.2172 5.89359 9.54108 6.89747 8.22038 8.22065L3.97888 12.4622M3.97888 5.80772V12.4622",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPath);
export default __webpack_public_path__ + "static/media/arrow-path.8729c6f38b0a72bbd9a8217d3632afad.svg";
export { ForwardRef as ReactComponent };